module.exports = __webpack_public_path__ + "static/poster3-aa27695532a5fbe577970290c27fa8f0.png";